// extracted by mini-css-extract-plugin
export default {"dropdown":"select_dropdown__o7b6U","select":"select_select__JF4qB"};